import{a as e}from"./chunk-QEKOZYJ5.js";import{a as r}from"./chunk-RAAYCPUM.js";function u(...n){return r(a,n)}var a=(n,o)=>e(n,t=>t<o);export{u as a};
